import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { _T } from 'appI18n';
import { useHotelRecommendations } from '../../../../TourSearch/store/TourDescriptionStore';
import AsyncLoadError from '../AsyncLoadError';
import HotelRecommendations from './HotelRecommendations';
export default function HotelRecommendationsContainer({ isFrame, hash }) {
    const [ref, inView] = useInView({ rootMargin: '50px 0px' });
    const [{ recommendations, loading, initialized, errors }, actions] = useHotelRecommendations(isFrame);
    useEffect(() => {
        if (!inView || initialized || loading)
            return;
        actions.loadHotelRecommendations();
    }, [inView]);
    return React.createElement("div", { ref: ref }, !errors.length
        ? React.createElement(HotelRecommendations, { recommendations: recommendations || [], loading: !initialized || loading, isFrame: isFrame, hash: hash })
        : React.createElement(AsyncLoadError, { errorText: _T.TOUR_ERROR_LOADING_HOTEL_RECOMMENDATIONS }));
}
